<template>
  <MessengerList/>
</template>
<script>
import MessengerList from '@/components/modules/schoolroutes/messenger/list'
export default {
  name: 'messenger',
  components: {
    MessengerList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/messenger/list.vue